
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#1CCB95","d":"M22.25 26a2.25 2.25 0 002.25-2.25V7.25A2.25 2.25 0 0022.25 5H20V2.563A.563.563 0 0019.437 2h-.375a.563.563 0 00-.562.563V5h-9V2.563A.563.563 0 008.937 2h-.375A.563.563 0 008 2.563V5H5.75A2.25 2.25 0 003.5 7.25v16.5A2.25 2.25 0 005.75 26h16.5zM23 9.5H5V7.25a.75.75 0 01.75-.75h16.5a.75.75 0 01.75.75V9.5zm-.75 15H5.75a.75.75 0 01-.75-.75V11h18v12.75a.75.75 0 01-.75.75zm-9.434-2.87l6.318-6.268a.563.563 0 00.003-.796l-.396-.4a.563.563 0 00-.796-.003l-5.521 5.477-2.365-2.371a.563.563 0 00-.796-.001l-.398.397a.563.563 0 00-.002.796l3.158 3.167c.219.22.575.22.795.002z"}})])
          )
        }
      }
    